import { headerBgType } from './HeaderBgStore';

export const updateHeaderBgType = (value) => headerBgType.update(oldValue => value);
